export default {
  isLogined: false, // 登录状态
  isLoading: false,  // 加载状态
  loadingInstance: null,  // 加载实例
  cartList: [],   // 加入购物车列表
  showMoveImg: false, // 显示飞入图片
  elLeft: 0,
  elTop: 0,
  moveImgUrl: null,
  cartPositionT: 0, // 购物车位置
  cartPositionL: 0,
  receiveInCart: false, // 是否进入购物车
  showCart: false // 是否显示购物车
}



// WEBPACK FOOTER //
// ./src/store/state.js